import { Tooltip } from "antd";
import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { ChangeBankAccountModal } from "./ChangeBankAccountModal";
import { ReactComponent as EditIcon } from "images/editIcon.svg";

interface IProps {
  bankAccountId?: string;
}

export const ChangeBankAccountButton = observer((props: IProps) => {
  const { actionModals } = useStores();
  const { bankAccountId } = props;
  const changeBankAccountHandler = () => {
    actionModals.open(() => <ChangeBankAccountModal bankAccountId={bankAccountId} />, {
      width: "600px",
      noValidation: true,
      title: "Выберите реквизиты для получения платежа по заявке",
      isOverlayClose: false,
      onApply: () => {
        return Promise.resolve();
      },
    });
  };
  return (
    <Tooltip title="Изменить реквизиты">
      <EditIcon className="cursor-pointer" onClick={changeBankAccountHandler} />
    </Tooltip>
  );
});
